import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'Error',
  props: {
    cssStyle: {
        type: String,
        default: '',
    },
},
  emits: ['refresh'],
  setup(__props, { emit }) {

const props = __props;



const errorImg = computed(() => {
    return props.cssStyle === 'black' ? require('../images/empty_dark.png') : require('../images/empty.png');
});
const refresh = () => {
    emit('refresh');
};

return { __sfc: true,emit, props, errorImg, refresh }
}

})